"use client"
import { useSyncExternalStore } from "react"
import { communicationsStore } from "./state"
export function useCommunications() {
  return useSyncExternalStore(communicationsStore.subscribe, communicationsStore.getSnapshot, communicationsStore.getServerSnapshot)
}
